import request from '@/utils/request'

/** 获取订单可用优惠券列表 */
export function getOrderAvailableVoucherList(query) {
  return request({
    url: '/enrollment/voucher/getOrderAvailableVoucherList',
    method: 'get',
    params: query
  })
}
